import React, { useState } from "react";
import { Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";
import Pagination from "../../../../ETMF/Pagination/Pagination";

const STDMMethodTableData = ({
  stdmMethod,
  tableRef,
  onMouseDown,
  getCDISCMathods,
  studyId,
  setIsFormOpen,
}) => {
  const [highlightedRow, setHighlightedRow] = useState(null);
  const deleteStudyDataByMathodId = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete Method!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let results = await cdiscServices.deleteStudyDataByMathodId(
          id,
          studyId
        );
        if (results?.statusCode === 200) {
          getCDISCMathods();
        }
      }
    });
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = stdmMethod?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(stdmMethod?.length / itemsPerPage);
  return (
    <>
      <div className="overflow-auto">
        <Table
          ref={tableRef}
          id="resizable-table"
          className="text-nowrap custom-table"
          hover
          striped
        >
          <thead className="thead-sticky z-1" style={{ top: -1 }}>
            <tr>
              <th
                onMouseDown={(e) => onMouseDown(e, 0)}
                style={{ width: 40 }}
                className="text-center"
              >
                Sr.
              </th>
              <th onMouseDown={(e) => onMouseDown(e, 1)}>ID</th>
              <th onMouseDown={(e) => onMouseDown(e, 2)}>Name</th>
              <th onMouseDown={(e) => onMouseDown(e, 3)}>Type</th>
              <th onMouseDown={(e) => onMouseDown(e, 4)}>Description</th>
              <th onMouseDown={(e) => onMouseDown(e, 5)}>Expression Context</th>
              <th onMouseDown={(e) => onMouseDown(e, 6)}>Expression Code</th>
              <th onMouseDown={(e) => onMouseDown(e, 7)}>Document</th>
              <th onMouseDown={(e) => onMouseDown(e, 8)}>Pages</th>
              <th
                onMouseDown={(e) => onMouseDown(e, 9)}
                style={{ width: 50, right: 50 }}
                className="text-center position-sticky"
              >
                <div className="text-center">Update</div>
              </th>
              <th
                onMouseDown={(e) => onMouseDown(e, 10)}
                style={{ width: 50, right: -1 }}
                className="text-center position-sticky"
              >
                <div className="text-center">Delete</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {result?.map((item, index) => (
              <tr
                key={index}
                className={`position-relative CP ${
                  highlightedRow === index && "activeMenu"
                }`}
                onClick={() => {
                  setHighlightedRow(index);
                }}
              >
                <td className="text-center">
                  {(pageNumber - 1) * itemsPerPage + index + 1}
                </td>
                <td>{item.mathodId}</td>
                <td>{item.name}</td>
                <td>{item.type}</td>
                <td>{item.description}</td>
                <td>{item.expressionContext}</td>
                <td>{item.expressionCode}</td>
                <td>{item.document}</td>
                <td>{item.pages}</td>
                <td style={{ right: 50 }}
                  className="position-sticky bg-light text-center">
                  <button
                    onClick={() => setIsFormOpen(item)}
                    title="Update"
                    className="text-white border-success bg-success border-0"
                    style={{ fontSize: 10, borderRadius: 3 }}
                  >
                    Update
                  </button>
                </td>
                <td
                  style={{ right: -1 }}
                  className="position-sticky bg-light text-center"
                >
                  <button
                    className="text-white border-danger bg-danger border-0"
                    style={{ fontSize: 10, borderRadius: 3 }}
                    title="Delete Supplementary"
                    onClick={() => deleteStudyDataByMathodId(item?._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="position-sticky bottom-0">
        <Pagination
          totalPage={totalPage}
          pageNumber={pageNumber}
          itemsPerPage={itemsPerPage}
          totalItems={stdmMethod?.length}
          setPageNumber={setPageNumber}
          setItemsPerPage={setItemsPerPage}
        />
      </div>
    </>
  );
};

export default STDMMethodTableData;
